export default {
    breadcrumb: {
        padding: "0.5rem 0rem",
        marginBottom: 0,
    },

    breadcrumbItem: {
        display: "inline-block",
        marginRight: "0.125rem",
    },

    breadcrumbActiveItem: {
        color: "#6c757d",
    },

    breadcrumbLink: {
        textDecoration: "underline",
    },

    breadcrumbSeparator: {
        color: "#6c757d",
        marginRight: "0.125rem",
        marginLeft: "0.125rem",
        display: "inline",
    }
}